import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-group-chat-icon',
  templateUrl: './communication-group-chat.component.html'
})
export class CommunicationGroupChatComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
